import { Injectable } from '@angular/core';
import { BaseService } from './base.service';

@Injectable()
export class UserInstituteDepartamentService {

    path = '/user-institute-departament';

    constructor(private baseService: BaseService) {}

    saveDepartaments(record) {
        return this.baseService.post(this.path, '/', record);
    }

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/user-institute-departament.service.ts